import { Component } from '@angular/core';
import { NavController, Events, App, LoadingController, NavParams } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { WeeklyAdCommon } from './weekly-ad.common';
import { WeeklyAdData } from '../../providers/weekly-ad-data';
import { ProductDetailPageFull } from './../../../product/pages/product-detail/product-detail.full';
import { Helpers } from '../../../../providers/helpers';
import { ElasticResult } from '../../../../providers/elastic-search';
import { StoreLocatorData } from '../../../store-locator/providers/store-locator-data';
declare var fabric: any;


@Component({
	selector: 'page-weekly-ad-full',
  	templateUrl: 'weekly-ad.full.html'
})

export class WeeklyAdPageFull extends PageBaseFull {
	
	public loader: any;
	public canvas: any;
	public circular: any;
	public weeklyAdId: any;
	public pageIndex: any;
	public circularPageIds: any;
	public currentStore : any;
	public weeklyAd: any = {};
	private noWeeklyAd: boolean = false;
	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: WeeklyAdCommon,
		public app: App,
		public weeklyAdData: WeeklyAdData,
		public loadingCtrl: LoadingController,
		private navParams: NavParams,
		private helpers: Helpers,
		public storeLocatorData: StoreLocatorData

	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
		this.weeklyAdId = navParams.get('id');
		this.pageIndex = navParams.get('pindex') || 0;
	}
	
	ionViewDidEnter() {
		this.app.setTitle('Weekly Ad');
		this.initPage();
	}

	ngAfterViewInit() {
	}

	public loadData() {
		var self = this;
		self.loader.present();
		if(self.weeklyAdId){
			self.weeklyAdData.getWeeklyAd(self.weeklyAdId).subscribe(weeklyAd => {
				// console.log(weeklyAd);
				this.weeklyAd = weeklyAd;
				if(weeklyAd){
					self.weeklyAdData.getCircular(weeklyAd.onlineCircularId).subscribe(circular =>{
						// console.log(circular);
						self.loadCircular(circular);
						self.loader.dismiss();
					});
				}else{
					this.noWeeklyAd = true;
				}
			});	
		}else{
			var storeId = this.currentStore.$key;
			if(storeId){
				self.weeklyAdData.getWeeklyAds(storeId).subscribe((weeklyAds:ElasticResult) => {
					self.loader.dismiss();
					if(weeklyAds && weeklyAds.items && weeklyAds.items.length > 0){
						if(weeklyAds.items.length === 1){
							var weeklyAd = weeklyAds.items[0];
							this.weeklyAd = weeklyAd;
							this.nav.push(WeeklyAdPageFull, { id: weeklyAd.$key, pindex: 0 });
							return;
						}
					}else{
						this.noWeeklyAd = true;
					}
				});	
			}
		}		
	}

	public loadCircular(circular){
		let self = this;
		self.canvas = new fabric.Canvas('canvas');

		self.circularPageIds = [];

		_.each(circular.pages, function(page, key){
			self.circularPageIds.push({id: key, order: page.order});
		});

		self.circularPageIds = _.sortBy(self.circularPageIds, 'order');

		let curPageId = self.circularPageIds[self.pageIndex].id;
		let curPageData = circular.pages[curPageId];

		console.log(curPageData);
		if(curPageData){
			self.canvas.loadFromJSON(curPageData.data, function() {
	            if (curPageData.width && curPageData.height) {
	                self.canvas.setWidth(curPageData.width);
	                self.canvas.setHeight(curPageData.height);
	            }
	            self.canvas.renderAll();
	            self.canvas.calcOffset();

	            self.fitToScreen();
	        });
		}
	}

	public fitToScreen(){
		let self = this;
		let viewPort = (<any>document.getElementById('viewport'));
		if(viewPort){
            let scale = viewPort.offsetWidth / self.canvas.getWidth();
            self.canvas.setZoom(scale);
            self.canvas.setHeight(self.canvas.height * scale);
            self.canvas.setWidth(self.canvas.width * scale);
        }		
	}

	public viewProductDetail(productId){
		this.nav.push(ProductDetailPageFull, { id: productId });
	}

	public goToPage(pageIndex){
		this.nav.push(WeeklyAdPageFull, { id: this.weeklyAdId, pindex: pageIndex });
	}

	public nextPage(){
		let newIndex = (Number(this.pageIndex) < this.circularPageIds.length - 1) ? Number(this.pageIndex) + 1 : this.pageIndex;

		this.goToPage(newIndex);
	}

	public prevPage(){
		let newIndex = (Number(this.pageIndex) > 0) ? Number(this.pageIndex) - 1 : 0;

		this.goToPage(newIndex);
	}
	
	public initPage(){
		this.storeLocatorData.getCurrentStore().subscribe((store) => {
			this.currentStore = store;
			// if(!this.currentStore){
			// 	this.nav.setRoot(this.pageRef.get('store-locator'));
			// 	this.helpers.alert("Smart RETAIL","Please select store.");
			// 	return;
			// }else{
			this.loadData();
			// }
		});	
	}
}



// WEBPACK FOOTER //
// ./src/modules/weekly-ad/pages/weekly-ad/weekly-ad.full.ts